var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.sampleReport || _vm.getOpinion ?'disabled litleBadge':'litleBadge',_vm.option.selected?'selected':''],on:{"click":_vm.sendThink}},[_c('div',[_vm._v(_vm._s(_vm.option.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }